import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/CheckedModel/CheckedModel.ts";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createEvent, createStore } from 'effector';
import { isNotEmpty } from '@gmini/utils';
import { buildKeyByPath, getOnlyParents, sliceTreeByKeys, sliceTreeOverKeys } from "../ClassifierTree/utils";
export function createCheckedModel() {
  var setLastCheckedItem = createEvent({
    name: "setLastCheckedItem",
    sid: "hoc5gv"
  });
  var lastCheckedItem$ = createStore(null, {
    name: "lastCheckedItem$",
    sid: "-8ak7ur"
  }).on(setLastCheckedItem, function (prev, next) {
    return next;
  });
  var onChecked = createEvent({
    name: "onChecked",
    sid: "-l9br0p"
  });
  var removeChecked = createEvent({
    name: "removeChecked",
    sid: "46zqgn"
  });
  var resetChecked = createEvent({
    name: "resetChecked",
    sid: "h0rmgy"
  });
  var checked$ = createStore({}, {
    name: "checked$",
    sid: "ou1bud"
  }).on(onChecked, function (checked, _ref) {
    var value = _ref.value,
        shiftKeyPressed = _ref.shiftKeyPressed,
        children = _ref.children,
        key = _ref.key,
        flatTree = _ref.flatTree;
    var lastCheckedItem = lastCheckedItem$.getState();

    var nextChecked = _objectSpread({}, checked);

    function setItemChecked(k) {
      children.forEach(function (child) {
        var childKey = buildKeyByPath(child.path);

        if (childKey in nextChecked) {
          delete nextChecked[childKey];
        }
      });
      k in nextChecked && !value ? delete nextChecked[k] : nextChecked[k] = value;
    }

    setItemChecked(key);

    if (!shiftKeyPressed || !lastCheckedItem) {
      if (value) {
        setLastCheckedItem(key);
      } else {
        setLastCheckedItem(null);
      }
    } else if (shiftKeyPressed) {
      var toUnCheckItems = sliceTreeOverKeys(flatTree, lastCheckedItem, key);
      var toCheckItems = sliceTreeByKeys(flatTree, lastCheckedItem, key).map(function (item, _, arr) {
        return getOnlyParents(flatTree, item, arr);
      }).filter(isNotEmpty); // ансетим выбранные до этого ноды

      toUnCheckItems.filter(function (item) {
        var itemKey = buildKeyByPath(item.path);
        return checked[itemKey];
      }).forEach(function (item) {
        var itemKey = buildKeyByPath(item.path);
        setItemChecked(itemKey);
      });
      toCheckItems.forEach(function (item) {
        var itemKey = buildKeyByPath(item.path);

        if (checked[itemKey]) {
          return;
        }

        setItemChecked(itemKey);
      });
    }

    return nextChecked;
  }).on(removeChecked, function (state, key) {
    var nextChecked = _objectSpread({}, state);

    delete nextChecked[key];
    return nextChecked;
  }).reset(resetChecked);
  return {
    checked$: checked$,
    onChecked: onChecked,
    resetChecked: resetChecked,
    removeChecked: removeChecked
  };
}